import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserEditFormView } from './view';
import { useAppUserAccountQuery, useAppUserAccountUpdate } from '../../../types/generated';

export function UserEditForm() {
    const navigate = useNavigate();
    const { id: userId } = useParams<{ id: string }>();

    const { data } = useAppUserAccountQuery({ variables: { id: userId } });
    const selectedUser = data && data.appAccountUser;

    const [userUpdate, { loading }] = useAppUserAccountUpdate({
        onCompleted() {
            navigate('/extranet/team');
        },
    });

    const onSubmit = (values, form, callback) => {
        userUpdate({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    const onCancel = () => {
        navigate('/extranet/team');
    };

    return (
        <UserEditFormView
            user={selectedUser}
            loading={loading}
            onCancel={onCancel}
            onSubmit={onSubmit}
        />
    );
}
